function getProduct() {
  const data = document.querySelector("#ecoma-product-json");
  if (!data) return null;

  try {
    return JSON.parse(data.textContent);
  } catch {
    return null;
  }
}

function getCurrentVariant() {
  const input = document.querySelector(".product-variant-id");
  if (!input) return null;

  const product = getProduct();
  if (!product) return null;

  return product.variants.find(v => v.id == input.value);
}

function updatePurchaseBox() {
  const variant = getCurrentVariant();
  if (!variant) return;
  const product = getProduct();
if (!product) return;

  console.log("Updating:", variant);

  // ------------------------
  // Price
  // ------------------------

  const price = document.querySelector(".purchase-price");
 if (price) {

    price.style.opacity = "0";

    setTimeout(() => {
        price.textContent = "AED " + (variant.price / 100).toFixed(2);
        price.style.opacity = "1";
    },120);

}

  const button = document.querySelector("#summary-button");

if (button) {
  button.textContent =
    `Add ${variant.option1} to cart — AED ${(variant.price / 100).toFixed(0)}`;
}

  // ------------------------
  // Size Text
  // ------------------------

 const sizeText = document.querySelector(".purchase-selected-size");
if (sizeText) {
  sizeText.textContent = variant.option2;
}

// Boxes
const boxes = document.querySelector(".purchase-boxes");
if (boxes) {
  boxes.textContent = variant.boxes;
}

// Diapers
const diapers = document.querySelector(".purchase-diapers");
if (diapers) {
 diapers.textContent = variant.diapers;
}

const delivery = document.querySelector(".purchase-delivery");

if (delivery) {
    delivery.textContent = variant.delivery;
}

  // ------------------------
  // Routine Cards Active
  // ------------------------

document.querySelectorAll(".variant-card").forEach(card => {

    const routine = card.dataset.option1;

    const currentVariant = product.variants.find(v =>
        v.option1 === routine &&
        v.option2 === variant.option2
    );

    if (!currentVariant) return;

    card.classList.toggle("active", routine === variant.option1);

    const boxes = card.querySelector(".variant-boxes");
const diapers = card.querySelector(".variant-diapers");

    if(boxes){

    boxes.style.opacity="0";

    setTimeout(()=>{
        boxes.textContent=currentVariant.boxes;
        boxes.style.opacity="1";
    },120);

}

if(diapers){

    diapers.style.opacity="0";

    setTimeout(()=>{
        diapers.textContent=currentVariant.diapers;
        diapers.style.opacity="1";
    },120);

}

});

  // ------------------------
  // Size Buttons Active
  // ------------------------

  document.querySelectorAll(".size-btn").forEach(btn => {
  btn.classList.toggle(
    "active",
    btn.dataset.optionValue === variant.option2
  );
});
}

function watchVariant() {
  const input = document.querySelector(".product-variant-id");

  if (!input) return;

  const observer = new MutationObserver(updatePurchaseBox);

  observer.observe(input, {
    attributes: true,
    attributeFilter: ["value"]
  });

  input.addEventListener("change", updatePurchaseBox);

  updatePurchaseBox();
}

// ------------------------------------
// Routine Card Click
// ------------------------------------

document.addEventListener("click", function (e) {

  // ------------------------
  // Routine Click
  // ------------------------

  const routine = e.target.closest(".variant-card");

  if (routine) {

    const value = routine.dataset.option1;

    const radio = document.querySelector(
      `input[type="radio"][data-option-name="Choose your routine"][value="${value}"]`
    );

    if (radio) {
      radio.click();
    }

    return;
  }

  // ------------------------
  // Size Click
  // ------------------------

  const size = e.target.closest(".size-btn");

  if (size) {

    const value = size.dataset.optionValue;

    const radio = document.querySelector(
      `input[type="radio"][data-option-name="Choose your size"][value="${value}"]`
    );

    if (radio) {
      radio.click();
    }
  }

}); 


document.addEventListener("DOMContentLoaded", function () {
  watchVariant();

  setTimeout(function () {
    updatePurchaseBox();
  }, 100);
});